import React, { useState, useEffect } from 'react';
import { Form, Button, Select, Checkbox, Radio, Switch, Input, message, Icon } from 'antd';
import { connect } from 'react-redux';
import './index.scss';
import { SmartCollectTransactionOrders } from "../../../../models";
import { handleApiExceptions } from "../../../../app_methods";

const { Option } = Select;

const notificationCycleOptions = [
    { label: 'None', value: '' },
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Yearly', value: 'yearly' },
];

const expiryDateOptions = [
    { label: '24 hrs', value: '24_hrs' },
    { label: '3 days', value: '3_days' },
    { label: '7 days', value: '7_days' },
    { label: '1 month', value: '1_month' },
    { label: 'Custom', value: 'custom' },
];

const customExpiryUnit = (
    <Select style={{ width: 110 }}>
        <Select.Option value="hrs">Hours</Select.Option>
        <Select.Option value="days">Days</Select.Option>
        <Select.Option value="months">Months</Select.Option>
        <Select.Option value="years">Years</Select.Option>
    </Select>
);
const configurationRows = [
    {
        key: 'unique_request_number',
        label: 'Unique Request Number',
        initialValue: 'auto_generate',
        control: (
            <Radio.Group className="order-config-form__stacked-options">
                <Radio value="auto_generate">Auto Generate</Radio>
                <Radio value="manual_enter">Manual Enter</Radio>
            </Radio.Group>
        ),
    },
    {
        key: 'allowed_collection_modes',
        label: 'Collection Mode',
        initialValue: ['bank_account'],
        control: (
            <Checkbox.Group>
                <Checkbox value="bank_account">Bank Account</Checkbox>
                <Checkbox value="upi">UPI</Checkbox>
            </Checkbox.Group>

        ),
    },
    {
        key: 'payment_type',
        label: 'Payment Type',
        initialValue: 'single_payment',
        control: (
            <Radio.Group className="order-config-form__stacked-options">
                <Radio value="single_payment">Single Payment</Radio>
                <Radio value="multiple_payment">Multiple Payment</Radio>
            </Radio.Group>
        ),
    },
    {
        key: 'notification_cycle_type',
        label: 'Notification Cycle',
        initialValue: 'monthly',
        control: (
            <Select className="order-config-form__select" getPopupContainer={triggerNode => triggerNode.parentNode}>
                {notificationCycleOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        ),
    },
    {
        key: 'notify_customer_on_create',
        label: 'Notify Customer on Create',
        initialValue: true,
        valuePropName: 'checked',
        control: <Switch />,
    },
    {
        key: 'expiry_date',
        label: 'Expiry Date',
        initialValue: '7_days',
        control: (
            <Select className="order-config-form__select" allowClear={true} getPopupContainer={triggerNode => triggerNode.parentNode}>
                {expiryDateOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        ),
    },
];
const DEFAULT_CONFIGURATION = {
    unique_request_number: "auto_generate",
    allowed_collection_modes: ["bank_account", "upi"],
    payment_type: "single_payment",
    notification_cycle_type: "",
    notify_customer_on_create: false,
    expiry_date: "24_hrs",
};

let OrderConfigurationForm = (props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { form } = props;
    const { getFieldDecorator, validateFields, setFieldsValue, getFieldValue, } = form;
    // OrderConfiguration
    useEffect(() => {
        fetchConfiguration();
    }, []);
    const fetchConfiguration = async () => {
        try {
            const response =
                await SmartCollectTransactionOrders.get_dynamic_form({
                    entity_type: "ORDER",
                });
            if (!response.success) {
                return;
            }
            const fields = response?.data?.data?.dynamic_forms || [];
            if (!fields.length) {
                setFieldsValue(DEFAULT_CONFIGURATION);
                return;
            }
            const values = {};
            fields.forEach((field) => {
                let value = field.default_value;
                switch (field.field_name) {
                    case "allowed_collection_modes":
                        try {
                            value = JSON.parse(value);
                        } catch (error) {
                            console.error("Failed to parse allowed_collection_modes:", error);
                            value = [];
                        }
                        break;
                    case "notify_customer_on_create":
                        value = value === "true";
                        break;
                    case "unique_request_number":
                        value =
                            value === "auto"
                                ? "auto_generate"
                                : "manual_enter";
                        break;
                    case "expiry_date":
                        if (!value) {
                            value = undefined;
                        } else {
                            const predefinedValues = [
                                "24_hrs",
                                "3_days",
                                "7_days",
                                "1_month",
                            ];

                            if (!predefinedValues.includes(value)) {
                                const parts = value.split("_");

                                if (parts.length === 2) {
                                    values.custom_expiry_value = Number(parts[0]);
                                    values.custom_expiry_unit = parts[1];
                                    value = "custom";
                                } else {
                                    value = undefined;
                                }
                            }
                        }

                        break;

                    default:
                        break;
                }
                values[field.field_name] = value;
            });

            form.setFieldsValue(values);
            if (values.expiry_date === "custom") {
                setTimeout(() => {
                    form.setFieldsValue({
                        custom_expiry_value: values.custom_expiry_value,
                        custom_expiry_unit: values.custom_expiry_unit,
                    });
                }, 0);
            }
        } catch (e) {
            handleApiExceptions(e);
        }
    };

    const onSubmit = (event) => {
        event.preventDefault();

        validateFields(async (error, values) => {
            if (error) {
                return;
            }

            setIsSubmitting(true);

            try {
                const payload = {
                    entity_type: "ORDER",
                    dynamic_forms: [],
                };

                configurationRows.forEach((row) => {
                    let value = values[row.key];

                    switch (row.key) {
                        case "allowed_collection_modes":
                            value = value || [];
                            break;

                        case "notify_customer_on_create":
                            value = value ? "true" : "false";
                            break;

                        case "unique_request_number":
                            value =
                                value === "auto_generate"
                                    ? "auto"
                                    : "manual";
                            break;
                        case "expiry_date":
                            if (!value) {
                                value = "";
                            } else if (value === "custom") {
                                value = `${values.custom_expiry_value}_${values.custom_expiry_unit}`;
                            }
                            break;

                        default:
                            break;
                    }

                    payload.dynamic_forms.push({
                        field_name: row.key,
                        field_label: row.label,
                        field_type: row.field_type,
                        default_value: value,
                        select_options: row.select_options || [],
                        row_placement: row.row_placement,
                        column_placement: row.column_placement,
                    });
                });
                const response = await SmartCollectTransactionOrders.save_dynamic_form(payload);
                if (!response.success) {
                    return;
                }
                message.success("Configuration updated successfully.");
                if (props.onClose) {
                    props.onClose();
                }
            } catch (error) {
                handleApiExceptions(error);
            } finally {
                setIsSubmitting(false);
            }
        });
    };


    return (
        <Form className="order-config-form" onSubmit={onSubmit}>
            <div className="order-config-form__header">
                <span>Fields</span>
                <span>Default Value</span>
            </div>

            <div className="order-config-form__rows">
                {configurationRows.map((row) => (
                    <div className="order-config-form__row" key={row.key}>
                        <div className="order-config-form__field-label">{row.label}</div>
                        <div className="order-config-form__field-control">
                            <Form.Item>
                                {getFieldDecorator(row.key, {
                                    initialValue: row.initialValue,
                                    valuePropName: row.valuePropName || 'value',
                                })(row.control)}
                            </Form.Item>
                        </div>
                    </div>
                ))}
                {getFieldValue("expiry_date") === "custom" && (
                    <div className="order-config-form__row">
                        <div className="order-config-form__field-label">
                            Custom Expiry
                        </div>

                        <div className="order-config-form__field-control">
                            <Form.Item>
                                {getFieldDecorator("custom_expiry_value", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Enter expiry value",
                                        },
                                    ],
                                })(
                                    <Input
                                        type="number"
                                        min={1}
                                        addonAfter={
                                            getFieldDecorator("custom_expiry_unit", {
                                                initialValue: "days",
                                            })(
                                                <Select style={{ width: 110 }}>
                                                    <Select.Option value="hrs">
                                                        Hours
                                                    </Select.Option>

                                                    <Select.Option value="days">
                                                        Days
                                                    </Select.Option>

                                                    <Select.Option value="months">
                                                        Months
                                                    </Select.Option>

                                                    <Select.Option value="years">
                                                        Years
                                                    </Select.Option>
                                                </Select>
                                            )
                                        }
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                )}
            </div>

            <div className="order-config-form__footer">
                <Button type="primary" htmlType="submit" loading={isSubmitting}>
                    Save Changes
                </Button>
            </div>
        </Form>
    );
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

OrderConfigurationForm = Form.create()(OrderConfigurationForm);
export default connect(mapStateToProps)(OrderConfigurationForm);
